import axios from "axios";

class Clients {
    getList() {
        return axios.get(`/api/v1/clients`);
    }
}

export default Clients;